<template>
  <div class="container">
    <Modal
      v-model="importResultModal"
      title="导入结果"
    >
      <div class="import-result-modal">
        <h3>
          成功导入{{
            importResultData ? importResultData.successImportCount : ""
          }}个，错误信息{{
            importResultData ? importResultData.errorData.length : ""
          }}个
        </h3>
        <div v-for="item in importResultList">{{ item }}</div>
      </div>
    </Modal>
    <Modal
        v-model="setReceiveTaskModal"
        title="设置回款任务"
        @on-ok="autoSetReceiveTaskMethod">
        <p>你确定要自动设置回款任务吗？</p>
        <p>自动设置回款任务会将客户账龄最长的月份自动设置为回款任务，如果金额不满10,000则往前顺延</p>
    </Modal>
    <Modal
      v-model="manualSetReceiveTaskModal"
      width="18"
      title="手动设置回款任务"
      >
      <InputNumber placeholder="回款任务金额"
        v-model="receiveTaskSum"
        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
        :parser="value => value.replace(/\$\s?|(,*)/g, '')"
        style="width: 120px"/>
      <div slot="footer">
        <Button @click="setReceiveTaskMethod">确认</Button>
      </div>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <h2 style="margin: 0 8px 0 16px">月份</h2>
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 100px; margin-right: 8px"
          v-model="yearMonth"
          @on-change="changeDate"
        />

        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 8px"
        ></Input>
        
        <Select
          placeholder="筛选业务员"
          v-model="salesVisible"
          label-in-value
          multiple
          filterable
          @on-change="choseSalesVisible"
          style="width: 180px; margin-right: 8px"
        >
          <Option
            v-for="item in salesVisibleMember"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
        <Select
          placeholder="筛选部门"
          v-model="department"
          label-in-value
          multiple
          filterable
          @on-change="choseDepartment"
          style="width: 180px; margin-right: 8px"
        >
          <Option
            v-for="item in departmentList"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
        <Button type="primary" @click="openSetReceiveTaskModal" style="margin-right: 8px">自动设置任务</Button>
        <i-switch v-model="displayARTable">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        <div>账龄表截止上个月底</div>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <Select
            v-model="limit"
            size="small"
            style="width: 60px; margin-right: 20px"
            @on-change="changeLimit"
          >
            <Option
              v-for="item in limitList"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option>
          </Select>
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="limit"
            @on-change="loadImportFileProcess"
            show-total
            simple
            style="min-width: 160px"
          />
        </div>
        <Button
          @click="exportReceiveTaskTable()"
          :loading="exportReceiveTaskTableTableLoading"
          style="margin-right: 12px"
        >导出回款任务</Button>
        <Button
          @click="$refs.ImportARTableModal.openModal()"
          style="margin-right: 12px"
        >Excel导入账龄表</Button>
      </div>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
    >
      <Table
        :columns="dynamicColumns"
        :data="statViewBParsed"
        :height="tableHeight"
        :loading="tableLoading"
        border
      >

        <template slot-scope="{ row, column, index }" slot="receiveAmountBefore">
          <div style="font-weight: bold; color: green;">{{ row.receiveAmountBefore[column._index-4] }}</div>
        </template>

        <template slot-scope="{ row, column, index }" slot="receiveTask">
          <div style="display: flex; justify-content: space-between; height: 21px;">
            <div style="display: flex; align-items: baseline; gap: 2px; width: 85px;">
              <div style="font-size: 10px;">已回</div>
              <!-- {{ column._index-4 }} -->
              <div style="font-weight: bold; color: green; width: 46px;">{{ row.receivedThisMonth }}</div>
            </div>
            <div style="display: flex; align-items: baseline; gap: 2px;">
              <div style="font-size: 10px;">剩余</div>
              <div style="font-weight: bold; width: 46px;">{{ row.leftReceiveTask }}</div>
            </div>
          </div>

          <div style="display: flex; align-items: baseline;" v-if="row.receiveTaskSum">
            <div class="custom-progress-bar">
              <div class="custom-progress-bar-inside" :style="{width: row.taskFinishedPercentage}"></div>
            </div>
            <div style="width: 36px; font-size: 10px;">
              {{ row.taskFinishedPercentage }}
            </div>
          </div>
        </template>

        <template slot-scope="{ row, column, index }" slot="arTable">
          <div
            v-if="column._index-fixedColumnCounts < row.arTable?.length"
            @click="updateReceiveTaskMethod(row, column, index)"
            class="arTable-cell"
            :class="row.arTable[column._index-fixedColumnCounts].cellClass">

            <div class="space-between">
              <div class="cell-yearmonth">
                {{ row.arTable[column._index-fixedColumnCounts].yearMonthDisplay }}
              </div>
              <div class="cell-diff-month"
                :style="{ color: row.arTable[column._index-fixedColumnCounts].diffColor }">
                {{ row.arTable[column._index-fixedColumnCounts].diffMonth }}
              </div>              
            </div>
            <div>
              {{ row.arTable[column._index-fixedColumnCounts].arDisplay }}              
            </div>
          </div>
          <div v-else>
            -
          </div>

        </template>
      </Table>
    </div>
    <ImportARTableModal
      ref="ImportARTableModal"
      @importResult="openImportResultModal"
    />
    <ARDetailDrawer ref="ARDetailDrawer" />
    <CustomerCommentDrawer ref="CustomerCommentDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import ImportARTableModal from "@/views/ImportARTablePage/ImportARTableModal.vue";
import ARDetailDrawer from "@/views/ImportARTablePage/ARDetailDrawer.vue";
import CustomerCommentDrawer from "@/views/ReceiveTaskPage/CustomerCommentDrawer.vue";
import axios from "@/utils/axios";
import _ from "lodash";
import dayjs from "dayjs";

export default {
  name: "ReceiveTask",
  components: {
    ImportARTableModal,
    ARDetailDrawer,
    CustomerCommentDrawer,
  },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      limit: 20,
      page: 0,
      salesVisible: "",
      department: "",
      tableLoading: false,
      importResultModal: false,
      setReceiveTaskModal: false,
      importResultData: null,
      importResultList: null,
      filterQuery: {},
      limitList: [
        { value: 20, label: "20" },
        { value: 100, label: "100" },
        { value: 300, label: "300" },
      ],
      manualSetReceiveTaskModal: false,
      columns: [
        {
          title: "部门",
          key: "department",
          align: "left",
          fixed: "left",
          width: 60,
          render: (h, params) => {
            return h(
              "div",
              params.row.customer.department
                ? params.row.customer.department.name
                : ""
            );
          },
        },
        {
          title: "业务员",
          key: "paymentSales",
          align: "center",
          fixed: "left",
          width: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.customer.paymentSales.map((x) => x.name).join(",")
            );
          },
        },
        {
          title: "公司",
          key: "paymentSales",
          align: "center",
          fixed: "left",
          width: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.company ? params.row.company.abbr || params.row.company.name : ''
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          width: 190,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.$refs.CustomerCommentDrawer.openDrawer(
                      params.row,
                    );
                  },
                },
              },
              this.dataTransform(params.row.customer, "name")
            );
          },
        },
        {
          title: "前月回款",
          key: "receivedLastLastMonth",
          fixed: "left",
          align: "right",
          width: 80,
          slot: 'receiveAmountBefore'
        },
        {
          title: "上月回款",
          key: "receivedLastMonth",
          fixed: "left",
          align: "right",
          width: 80,
          slot: 'receiveAmountBefore'
        },
        {
          title: "本月回款",
          key: "receivedThisMonth",
          fixed: "left",
          align: "right",
          width: 180,
          slot: 'receiveTask'
        },
        {
          title: "本月回款任务",
          key: "receiveTaskSum",
          fixed: "left",
          align: "right",
          width: 120,
          render: (h, params) => {
            return h(
              "div",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.receiveTaskSum = null
                    this.manualSetReceiveTaskModal = true
                    this.selectedReceiveTask = params.row
                  },
                },
              },
              params.row.receiveTaskSum
                ? Number(params.row?.receiveTaskSum).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                : "-"
            );
          },
        },
        {
          title: "应收总额",
          key: "totalAccountsReceivable",
          fixed: "left",
          align: "right",
          width: 120,
          render: (h, params) => {
            return h(
              "div",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.$refs.ARDetailDrawer.openDrawer(
                      params.row,
                      this.yearMonth
                    );
                  },
                },
              },
              params.row.totalAccountsReceivable
                ? Number(params.row?.totalAccountsReceivable).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                : "-"
            );
          },
        },
        // {
        //   title: "逾期总额",
        //   key: "totalPastDueAR",
        //   align: "right",
        //   fixed: "left",
        //   minWidth: 120,
        //   render: (h, params) => {
        //     return h(
        //       "div",
        //       params.row.totalPastDueAR
        //         ? Number(params.row?.totalPastDueAR).toLocaleString("zh", {
        //             minimumFractionDigits: 2,
        //             maximumFractionDigits: 2,
        //           })
        //         : "-"
        //     );
        //   },
        // },
        {
          title: "账龄",
          key: "longestARMonthCount",
          align: "right",
          fixed: "left",
          width: 60,
          render: (h, params) => {
            return h("div", params.row.longestARMonthCount);
          },
        },
        
      ],
      receiveTaskSum: null,
      displayARTable: false,
      fixedColumnCounts: 10,
      salesVisibleMember: [],
      departmentList: [],
      yearMonth: null,
      exportReceiveTaskTableTableLoading: false,
      selectedReceiveTask: null
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
      statViewB: (state) => state.salesStat.statViewB,
      totalRows: (state) => state.salesStat.statViewBCounts,
    }),
    statViewBParsed: function () {
      const parsedData = [];
      for (const stat of this.statViewB) {
        const arTable = []
        for (const arCell of stat.arTable) {
          const arTableYearMonth = `${arCell.year}-${arCell.month}`

          const diffMonth = dayjs(this.yearMonth).diff(arTableYearMonth, "month");
          let diffColor;
          if (diffMonth >= 12) {
            diffColor = 'red';
          }
          let arDisplay = arCell.accountsReceivable;
          if (arDisplay) {
            arDisplay = (arDisplay / 10000).toFixed(2);
          }
          let cellClass = '';
          if (arCell.receiveTaskPercentage >= 1) {
            cellClass = 'arTable-cell-selected';
          } else if (arCell.receiveTaskPercentage > 0) {
            cellClass = 'arTable-cell-selected-half';
          }
          arTable.push({
            ...arCell,
            yearMonthDisplay: `${String(arCell.year).slice(-2)}/${arCell.month}`,
            diffMonth,
            arDisplay,
            diffColor,
            cellClass,
          })
        }
        let receivedThisMonth = '-';
        if (stat.receivedThisMonth > 0) receivedThisMonth = (stat.receivedThisMonth/10000).toFixed(1) + 'w';
        let leftReceiveTask = '-';
        let taskFinishedPercentage = '0';
        if (stat.receiveTaskSum) {
          const leftAmount = stat.receiveTaskSum - (stat.receivedThisMonth || 0);
          if (leftAmount > 0) {
            leftReceiveTask = (leftAmount/10000).toFixed(1) + 'w';
            taskFinishedPercentage = `${(stat.receivedThisMonth / stat.receiveTaskSum * 100).toFixed(0)}%`;
          } else {
            taskFinishedPercentage = '100%';
          }
        }
        let receiveAmountBefore = ['-', '-'];
        if (stat.receiveMonthList[0]) receiveAmountBefore[0] = (stat.receiveMonthList[0]/10000).toFixed(1) + 'w';
        if (stat.receiveMonthList[1]) receiveAmountBefore[1] = (stat.receiveMonthList[1]/10000).toFixed(1) + 'w';
        parsedData.push({
          ...stat,
          arTable,
          receivedThisMonth,
          leftReceiveTask,
          taskFinishedPercentage,
          receiveAmountBefore
        })
      }
      return parsedData;
    },
    dynamicColumns: function() {
      if (this.displayARTable) {
        const arCol = []
        for (let i = 0; i < 24; i++) {
          arCol.push({
            title: " ",
            key: "arTable",
            slot: `arTable`,
            align: "right",
            minWidth: 70,
          })
        }
        return [ ...this.columns, ...arCol ]
      }
      return this.columns;
    }
  },
  
  methods: {
    ...mapActions({
      getStatViewB: "salesStat/getStatViewBAction",
      updateReciveTask: "salesStat/updateReciveTaskAction",
      autoSetReceiveTask: "salesStat/autoSetReceiveTaskAction",
      setReceiveTask: "salesStat/setReceiveTaskAction",
      getUsersList: "user/getSimpleUserListAction",
      getDepartmentList: "department/getDepartmentListAction",
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    // 数据处理
    dataTransform(params, item) {
      let value = null;
      if (params && params.abbr) {
        value = params.abbr;
      } else {
        value = _.get(params, item, "-");
      }
      return value;
    },
    async loadImportFileProcess(page) {
      this.columns.splice(10, this.columns.length - 2);
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        // limit: 1,
        limit: this.limit,
        tableMode: "modeB",
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      this.$router.push({
        path: `/home/receive_task`,
        query: {
          ...this.filterQuery,
        },
      });
      try {
        this.tableLoading = true;
        const data = await this.getStatViewB(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadImportFileProcess();
    }, 1000),
    // 切换日期
    changeDate(e) {
      if (e) {
        this.columns.splice(10, this.columns.length - 2);
        this.filterQuery.year = e.split("-")[0];
        this.filterQuery.month = e.split("-")[1];
      } else {
        this.yearMonth = dayjs().subtract(1, "month").format("YYYY-M");
        this.filterQuery.year = dayjs(this.yearMonth).year();
        this.filterQuery.month = dayjs(this.yearMonth).month() + 1;
      }
      this.loadImportFileProcess();
    },
    // 切换limit
    changeLimit() {
      this.page = 0;
      this.loadImportFileProcess();
    },
    // 获取业务员
    async getSalesVisibleMethod() {
      const data = await this.getUsersList({
        simpleRole: "salesLead,sales,salesAssist",
        limit: 99,
      });
      this.salesVisibleMember = data.userList;
    },
    // 选择了业务员后获取账龄表
    async choseSalesVisible(salesVisibleMember) {
      if (salesVisibleMember) {
        this.filterQuery.paymentSales = salesVisibleMember
          .map((x) => x.value)
          .join(",");
      } else {
        delete this.filterQuery.paymentSales;
      }
      await this.loadImportFileProcess();
    },
    async getDepartmentMethod() {
      const data = await this.getDepartmentList({
        limit: 99,
        skip: 0
      });
      this.departmentList = data;
    },
    async choseDepartment(department) {
      if (department) {
        this.filterQuery.department = department.map((x) => x.value).join(",");
      } else {
        delete this.filterQuery.department;
      }
      await this.loadImportFileProcess();
    },
    openImportResultModal(e) {
      this.importResultModal = true;
      this.importResultData = e;
      this.importResultList = e.errorData;
    },
    // dataHandle(row, column, index) {
    //   const arIndex = Number(column._index-fixedColumnCounts)
    //   if (arIndex < row.arTable.length) {
    //     // 计算逾期月份
    //     const arTableYearMonth =
    //       row.arTable[arIndex]?.year +
    //       "-" +
    //       row.arTable[arIndex]?.month;
    //     const diffYearMonth =
    //       dayjs(this.yearMonth).diff(arTableYearMonth, "month") + 1;
    //     const monthNum = `${diffYearMonth}个月`;
    //     let ar = row.arTable[arIndex]?.accountsReceivable;
    //     if (ar) {
    //       ar = (ar / 10000).toFixed(2);
    //     }
    //     const str = String(row.arTable[arIndex]?.year).slice(-2) + "/" + row.arTable[arIndex]?.month + "\n" + monthNum + "\n" + ar
    //     return str
    //   }
    // },
    // 添加回款任务
    async updateReceiveTaskMethod(row, column) {
      const arTableIndex = Number(column._index - this.fixedColumnCounts)
      const setReceiveTask = row.arTable[arTableIndex].receiveTaskPercentage < 1 ? 1 : 0;
      const year = row.arTable[arTableIndex].year
      const month = row.arTable[arTableIndex].month
      await this.updateReciveTask({ id: row._id, setReceiveTask, year, month})
    },
    openSetReceiveTaskModal() {
      this.setReceiveTaskModal = true
    },
    async autoSetReceiveTaskMethod() {
      await this.autoSetReceiveTask({year: this.filterQuery.year, month: this.filterQuery.month})
      this.loadImportFileProcess()
    },
    async setReceiveTaskMethod() {
      const formData = {}
      if (this.receiveTaskSum) {
        formData.setReceiveTask = this.receiveTaskSum
        formData.year = this.filterQuery.year
        formData.month = this.filterQuery.month
        try {
          await this.setReceiveTask({id: this.selectedReceiveTask._id, data: formData})
          this.$Message.success("保存成功!");
          this.manualSetReceiveTaskModal = false
        } catch (error) {
          this.$Message.error("设置失败", error);
        }
      } else {
        this.$Message.error("请填写回款任务金额");
      }
    },
    async exportReceiveTaskTable() {
      this.exportReceiveTaskTableTableLoading = true
      const date = dayjs(this.yearMonth).format('YYYY-M').split('-')
      const exportItem = {}
      exportItem.year = date[0]
      exportItem.month = date[1]
      try {
        const res = await axios.get(`/export_receive_task_table`, {
          responseType: "blob",
          params: { ...exportItem },
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `回款任务${dayjs(this.yearMonth).format("M月YYYY年")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        this.$Message.success("导出成功!");
      } catch (error) {
        this.$Message.error({
          content: `导出失败!${error}`,
          closable: true,
          duration: 0,
        });
      }
      this.exportReceiveTaskTableTableLoading = false
    },
  },
  async created() {
    let query = this.$route.query;
    if (query.month && query.year) {
      this.filterQuery.month = query.month;
      this.filterQuery.year = query.year;
      this.yearMonth = query.year + "-" + query.month;
    } else {
      this.yearMonth = dayjs().format("YYYY-M");
      this.filterQuery.year = dayjs().year();
      this.filterQuery.month = dayjs().month() + 1;
    }
    
    await this.loadImportFileProcess();
    
    this.getSalesVisibleMethod();
    this.getDepartmentMethod();
  },
  async mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.import-result-modal
  height 265px
  overflow hidden
  overflow-y auto

.arTable-cell
  white-space pre-wrap
  cursor pointer
  margin 0 -8px

.arTable-cell-selected
  background-color #ffffb5
  color #ff3e3e

.arTable-cell-selected-half
  background-color #ffffe7
  color #ff3e3e

.space-between
  display flex
  justify-content space-between
  align-items baseline

.cell-diff-month
  font-weight bold

.cell-yearmonth
  color darkgray

.custom-progress-bar
  width 100%
  border-radius 30px;
  height 4px
  background-color red

.custom-progress-bar-inside
  border-radius 30px;
  height 4px
  background-color rgb(66, 185, 131)
</style>